module.exports = __webpack_public_path__ + "media/logo/logo_lcl-46637308.png";